import ContractsTaxiForwardingContractUpdateRequest from "../../../../api/raily/contracts/taxi-forwarding/update/contracts-taxi-forwarding-contract-update.request";
import ContractsTaxiForwardingContractUpdateParams from "./contracts-taxi-forwarding-contract-update-params";

const create = (
  params: ContractsTaxiForwardingContractUpdateParams,
): ContractsTaxiForwardingContractUpdateRequest => {
  return {
    contractUuid: params.contractUuid,
    disabled: !params.isActive,
    displayName: params.displayName,
    priority: params.priority,
  };
};

const contractsTaxiForwardingContractUpdateParamsFactory = {
  create,
};

export default contractsTaxiForwardingContractUpdateParamsFactory;
